// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3m-1";
export var movingGradient = "_3m-4";
export var movingGradientBlock = "_3m-2";
export var skeleton = "_3m-0";
export var skeletonText = "_3m-3";